import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create Class
export const markStudentAttendence = data => post(url.MARK_STUDENT_ATTENDANCE, data);
export const markAllStudentAttendence = data => post(url.MARK_ALL_STUDENT_ATTENDANCE, data);
export const markTrainerAttendence = data => post(url.MARK_TRAINER_ATTENDANCE, data);


export const getAllStudentAttendence = ids => get(url.GET_ALL_STUDENT_ATTENDANCE + ids);
export const getTrainerAttendence = ids => get(url.GET_TRAINER_ATTENDANCE + ids);

